module.exports = __webpack_public_path__ + "static/media/4 greek mythology poseidon tattoo realism tattoo sleeve.1280x1707.6e62e9b1.webp";